import { combineReducers } from 'redux';
import {

	maintenanceResortList,
    marshaCodeList,
    tabledataList,
	
} from '../screens/Homescreen/MainReducer';
import { userGroup } from '../screens/Homescreen/MainReducer';

export default combineReducers({
    maintenanceResortList,
marshaCodeList,
tabledataList,
userGroup,

});
